<div class="marker-note-modal" *ngIf="visible" (click)="onBackdropClick()">
  <div class="modal-content" (click)="stopPropagation($event)">
    <div class="modal-header">
      <h4>
        {{
          (isEditing ? "markerNoteModal.editNote" : "markerNoteModal.addNote")
            | translate
        }}
      </h4>
      <button class="close-btn" (click)="onCancel()">&times;</button>
    </div>

    <div class="modal-body">
      <label for="markerNote">{{
        "markerNoteModal.noteLabel" | translate
      }}</label>
      <textarea
        id="markerNote"
        [(ngModel)]="currentNote"
        [placeholder]="'markerNoteModal.notePlaceholder' | translate"
        rows="4"
        (keydown)="stopPropagation($event)"
      ></textarea>
    </div>

    <div class="modal-footer">
      <button
        class="btn-delete"
        *ngIf="isEditing"
        (click)="onDelete()"
        style="margin-right: auto"
      >
        <i class="fas fa-trash"></i>
      </button>
      <button class="btn-cancel" (click)="onCancel()">
        {{ "markerNoteModal.cancel" | translate }}
      </button>
      <button class="btn-save" (click)="onSave()">
        {{ "markerNoteModal.save" | translate }}
      </button>
    </div>
  </div>
</div>
